import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/app/theme';

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      className="grid h-9 w-9 place-items-center rounded-md border border-line-2 bg-surface text-fg-dim transition-colors hover:text-fg focus:outline-none focus-visible:[box-shadow:var(--focus-ring)]"
    >
      {theme === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
